module.exports = __webpack_public_path__ + "static/media/ic_meeting_manage.a257b708.png";